export const EXAM_DATA = {
    math: {
        id: 'math',
        name: '2026届高三数学第一次模拟考试',
        subject: '高中数学',
        score: 150,
        questions: 22,
        defaultClasses: ['高三(1)班', '高三(2)班', '高三(3)班'],
        spaceIds: ['y1'],
    },
    math_month: {
        id: 'math_month',
        name: '2025-2026学年高三数学月考(一)',
        subject: '高中数学',
        score: 150,
        questions: 22,
        defaultClasses: ['高三(1)班', '高三(2)班'],
        spaceIds: ['y1', 'y2'],
    },
    chinese_final: {
        id: 'chinese_final',
        name: '2026年春季期末考试-语文',
        subject: '高中语文',
        score: 150,
        questions: 22,
        defaultClasses: ['高三(1)班', '高三(2)班', '高三(3)班'],
        spaceIds: ['y1', 'y2'],
    },
    english: {
        id: 'english',
        name: '2026年春季期末考试-英语',
        subject: '高中英语',
        score: 150,
        questions: 20,
        defaultClasses: ['高三(1)班', '高三(2)班', '高三(3)班'],
        spaceIds: ['y2'],
    },
    physics_unit: {
        id: 'physics_unit',
        name: '月考-物理',
        subject: '高中物理',
        score: 100,
        questions: 18,
        defaultClasses: ['高二(1)班', '高二(2)班'],
        spaceIds: ['y3'],
    },
    chem: {
        id: 'chem',
        name: '高二化学有机化学单元测试',
        subject: '高中化学',
        score: 100,
        questions: 20,
        defaultClasses: ['高二(1)班', '高二(2)班'],
        spaceIds: ['y1', 'y3'],
    },
};

export const PAPER_LIST_META = {
    math: { answerCount: 256, gradedCount: 192, progress: 75, status: '阅卷中' },
    chinese_final: { answerCount: 256, gradedCount: 256, progress: 100, status: '已完成' },
    english: { answerCount: 256, gradedCount: 115, progress: 45, status: '阅卷中' },
    physics_unit: { answerCount: 0, gradedCount: 0, progress: 0, status: '待开始' },
    chem: { answerCount: 180, gradedCount: 54, progress: 30, status: '阅卷中' },
    math_month: { answerCount: 200, gradedCount: 200, progress: 100, status: '已完成' },
};

export const PAPER_STUDENT_RESULTS = {
    math: [
        { id: '2023007', name: '吴九', cls: '高三(3)班', objective: 80, subjective: 62, total: 142, status: '已完成' },
        { id: '2023005', name: '钱七', cls: '高三(3)班', objective: 78, subjective: 58, total: 136, status: '已完成' },
        { id: '2023001', name: '张三', cls: '高三(1)班', objective: 78, subjective: 50, total: 128, status: '已完成' },
        { id: '2023002', name: '李四', cls: '高三(1)班', objective: 65, subjective: 50, total: 115, status: '已完成' },
        { id: '2023006', name: '周八', cls: '高三(2)班', objective: 60, subjective: 42, total: 102, status: '已完成' },
        { id: '2023003', name: '王五', cls: '高三(1)班', objective: 73, subjective: null, total: null, status: '阅卷中' },
        { id: '2023004', name: '赵六', cls: '高三(2)班', objective: 70, subjective: null, total: null, status: '待阅卷' },
    ],
    chinese_final: [
        { id: '2023007', name: '吴九', cls: '高三(3)班', objective: 79, subjective: 60, total: 139, status: '已完成' },
        { id: '2023005', name: '钱七', cls: '高三(3)班', objective: 77, subjective: 55, total: 132, status: '已完成' },
        { id: '2023004', name: '赵六', cls: '高三(2)班', objective: 76, subjective: 52, total: 128, status: '已完成' },
        { id: '2023001', name: '张三', cls: '高三(1)班', objective: 75, subjective: 50, total: 125, status: '已完成' },
        { id: '2023003', name: '王五', cls: '高三(1)班', objective: 72, subjective: 48, total: 120, status: '已完成' },
        { id: '2023002', name: '李四', cls: '高三(1)班', objective: 70, subjective: 48, total: 118, status: '已完成' },
    ],
    english: [
        { id: '2023003', name: '王五', cls: '高三(1)班', objective: 80, subjective: 55, total: 135, status: '已完成' },
        { id: '2023005', name: '钱七', cls: '高三(3)班', objective: 74, subjective: 62, total: 136, status: '已完成' },
        { id: '2023007', name: '吴九', cls: '高三(3)班', objective: 76, subjective: 58, total: 134, status: '已完成' },
        { id: '2023001', name: '张三', cls: '高三(1)班', objective: 72, subjective: 60, total: 132, status: '已完成' },
        { id: '2023004', name: '赵六', cls: '高三(2)班', objective: 70, subjective: 50, total: 120, status: '已完成' },
        { id: '2023002', name: '李四', cls: '高三(1)班', objective: 68, subjective: null, total: null, status: '阅卷中' },
        { id: '2023006', name: '周八', cls: '高三(2)班', objective: 58, subjective: null, total: null, status: '待阅卷' },
    ],
    physics_unit: [],
    chem: [
        { id: '2024001', name: '陈一', cls: '高二(4)班', objective: 52, subjective: 30, total: 82, status: '已完成' },
        { id: '2024002', name: '林二', cls: '高二(4)班', objective: 48, subjective: 28, total: 76, status: '已完成' },
        { id: '2024003', name: '黄三', cls: '高二(4)班', objective: 45, subjective: null, total: null, status: '阅卷中' },
        { id: '2024004', name: '刘四', cls: '高二(4)班', objective: 50, subjective: null, total: null, status: '待阅卷' },
    ],
    math_month: [
        { id: '2023001', name: '张三', cls: '高三(1)班', objective: 76, subjective: 58, total: 134, status: '已完成' },
        { id: '2023005', name: '钱七', cls: '高三(3)班', objective: 74, subjective: 56, total: 130, status: '已完成' },
        { id: '2023002', name: '李四', cls: '高三(1)班', objective: 68, subjective: 50, total: 118, status: '已完成' },
    ],
};

export const STUDENT_SYSTEM_DATA = [
    {
        id: '2023001', name: '张三', cls: '高三(1)班',
        exams: [
            { name: '2026年春季期末考试-数学', subject: '数学', type: '期末考试', date: '2026-06-15', objective: 78, subjective: 50, total: 128, status: '已完成' },
            { name: '2026年春季期末考试-英语', subject: '英语', type: '期末考试', date: '2026-06-16', objective: 72, subjective: 60, total: 132, status: '已完成' },
            { name: '2026年春季期末考试-语文', subject: '语文', type: '期末考试', date: '2026-06-14', objective: 64, subjective: 63, total: 127, status: '已完成' },
            { name: '月考一-物理', subject: '物理', type: '月考', date: '2026-03-20', objective: 48, subjective: 32, total: 80, status: '已完成' },
            { name: '月考一-化学', subject: '化学', type: '月考', date: '2026-03-21', objective: 52, subjective: 30, total: 82, status: '已完成' },
        ],
    },
    {
        id: '2023002', name: '李四', cls: '高三(1)班',
        exams: [
            { name: '2026年春季期末考试-数学', subject: '数学', type: '期末考试', date: '2026-06-15', objective: 65, subjective: 50, total: 115, status: '已完成' },
            { name: '2026年春季期末考试-英语', subject: '英语', type: '期末考试', date: '2026-06-16', objective: 68, subjective: 40, total: 108, status: '已完成' },
            { name: '2026年春季期末考试-语文', subject: '语文', type: '期末考试', date: '2026-06-14', objective: 70, subjective: 48, total: 118, status: '已完成' },
            { name: '月考一-物理', subject: '物理', type: '月考', date: '2026-03-20', objective: 40, subjective: 28, total: 68, status: '已完成' },
        ],
    },
    {
        id: '2023003', name: '王五', cls: '高三(1)班',
        exams: [
            { name: '2026年春季期末考试-数学', subject: '数学', type: '期末考试', date: '2026-06-15', objective: 73, subjective: null, total: null, status: '阅卷中' },
            { name: '2026年春季期末考试-英语', subject: '英语', type: '期末考试', date: '2026-06-16', objective: 80, subjective: 55, total: 135, status: '已完成' },
            { name: '2026年春季期末考试-语文', subject: '语文', type: '期末考试', date: '2026-06-14', objective: 72, subjective: 48, total: 120, status: '已完成' },
            { name: '月考一-物理', subject: '物理', type: '月考', date: '2026-03-20', objective: 45, subjective: 35, total: 80, status: '已完成' },
            { name: '月考一-化学', subject: '化学', type: '月考', date: '2026-03-21', objective: 50, subjective: 28, total: 78, status: '已完成' },
        ],
    },
    {
        id: '2023004', name: '赵六', cls: '高三(2)班',
        exams: [
            { name: '2026年春季期末考试-数学', subject: '数学', type: '期末考试', date: '2026-06-15', objective: 70, subjective: null, total: null, status: '待阅卷' },
            { name: '2026年春季期末考试-语文', subject: '语文', type: '期末考试', date: '2026-06-14', objective: 76, subjective: 52, total: 128, status: '已完成' },
            { name: '2026年春季期末考试-英语', subject: '英语', type: '期末考试', date: '2026-06-16', objective: 70, subjective: 50, total: 120, status: '已完成' },
        ],
    },
    {
        id: '2023005', name: '钱七', cls: '高三(3)班',
        exams: [
            { name: '2026年春季期末考试-数学', subject: '数学', type: '期末考试', date: '2026-06-15', objective: 78, subjective: 58, total: 136, status: '已完成' },
            { name: '2026年春季期末考试-英语', subject: '英语', type: '期末考试', date: '2026-06-16', objective: 74, subjective: 62, total: 136, status: '已完成' },
            { name: '2026年春季期末考试-语文', subject: '语文', type: '期末考试', date: '2026-06-14', objective: 77, subjective: 55, total: 132, status: '已完成' },
            { name: '月考一-物理', subject: '物理', type: '月考', date: '2026-03-20', objective: 55, subjective: 38, total: 93, status: '已完成' },
            { name: '月考一-化学', subject: '化学', type: '月考', date: '2026-03-21', objective: 58, subjective: 36, total: 94, status: '已完成' },
        ],
    },
    {
        id: '2023006', name: '周八', cls: '高三(2)班',
        exams: [
            { name: '2026年春季期末考试-数学', subject: '数学', type: '期末考试', date: '2026-06-15', objective: 60, subjective: 42, total: 102, status: '已完成' },
            { name: '2026年春季期末考试-英语', subject: '英语', type: '期末考试', date: '2026-06-16', objective: 58, subjective: 40, total: 98, status: '已完成' },
        ],
    },
    {
        id: '2023007', name: '吴九', cls: '高三(3)班',
        exams: [
            { name: '2026年春季期末考试-数学', subject: '数学', type: '期末考试', date: '2026-06-15', objective: 80, subjective: 62, total: 142, status: '已完成' },
            { name: '2026年春季期末考试-英语', subject: '英语', type: '期末考试', date: '2026-06-16', objective: 76, subjective: 58, total: 134, status: '已完成' },
            { name: '2026年春季期末考试-语文', subject: '语文', type: '期末考试', date: '2026-06-14', objective: 79, subjective: 60, total: 139, status: '已完成' },
            { name: '月考一-物理', subject: '物理', type: '月考', date: '2026-03-20', objective: 56, subjective: 40, total: 96, status: '已完成' },
        ],
    },
    {
        id: '2023018', name: '郑十一', cls: '高三(1)班',
        exams: [
            { name: '2026年春季期末考试-语文', subject: '语文', type: '期末考试', date: '2026-06-14', objective: 72, subjective: 70, total: 142, status: '已完成' },
            { name: '2026年春季期末考试-数学', subject: '数学', type: '期末考试', date: '2026-06-15', objective: 76, subjective: 58, total: 134, status: '已完成' },
            { name: '2026年春季期末考试-英语', subject: '英语', type: '期末考试', date: '2026-06-16', objective: 74, subjective: 60, total: 134, status: '已完成' },
        ],
    },
    {
        id: '2023045', name: '钱十二', cls: '高三(2)班',
        exams: [
            { name: '2026年春季期末考试-语文', subject: '语文', type: '期末考试', date: '2026-06-14', objective: 70, subjective: 68, total: 138, status: '已完成' },
            { name: '2026年春季期末考试-数学', subject: '数学', type: '期末考试', date: '2026-06-15', objective: 72, subjective: 55, total: 127, status: '已完成' },
            { name: '月考一-物理', subject: '物理', type: '月考', date: '2026-03-20', objective: 50, subjective: 35, total: 85, status: '已完成' },
        ],
    },
    {
        id: '2023072', name: '陈十三', cls: '高三(3)班',
        exams: [
            { name: '2026年春季期末考试-语文', subject: '语文', type: '期末考试', date: '2026-06-14', objective: 68, subjective: 67, total: 135, status: '已完成' },
            { name: '2026年春季期末考试-英语', subject: '英语', type: '期末考试', date: '2026-06-16', objective: 70, subjective: 58, total: 128, status: '已完成' },
        ],
    },
    {
        id: '2023023', name: '吴十四', cls: '高三(1)班',
        exams: [
            { name: '2026年春季期末考试-语文', subject: '语文', type: '期末考试', date: '2026-06-14', objective: 66, subjective: 66, total: 132, status: '已完成' },
            { name: '2026年春季期末考试-数学', subject: '数学', type: '期末考试', date: '2026-06-15', objective: 68, subjective: 52, total: 120, status: '已完成' },
        ],
    },
    {
        id: '2023089', name: '王十五', cls: '高三(3)班',
        exams: [
            { name: '2026年春季期末考试-语文', subject: '语文', type: '期末考试', date: '2026-06-14', objective: 65, subjective: 65, total: 130, status: '已完成' },
            { name: '月考一-化学', subject: '化学', type: '月考', date: '2026-03-21', objective: 55, subjective: 32, total: 87, status: '已完成' },
        ],
    },
    {
        id: '2023056', name: '赵十六', cls: '高三(2)班',
        exams: [
            { name: '2026年春季期末考试-语文', subject: '语文', type: '期末考试', date: '2026-06-14', objective: 62, subjective: 62, total: 124, status: '已完成' },
            { name: '2026年春季期末考试-英语', subject: '英语', type: '期末考试', date: '2026-06-16', objective: 66, subjective: 48, total: 114, status: '已完成' },
        ],
    },
];

export const STATS_RANKING = [
    { rank: 1, id: '2023018', name: '郑十一', cls: '高三(1)班', objective: '72/80', subjective: '70/70', total: 142 },
    { rank: 2, id: '2023045', name: '钱十二', cls: '高三(2)班', objective: '70/80', subjective: '68/70', total: 138 },
    { rank: 3, id: '2023072', name: '陈十三', cls: '高三(3)班', objective: '68/80', subjective: '67/70', total: 135 },
    { rank: 4, id: '2023023', name: '吴十四', cls: '高三(1)班', objective: '66/80', subjective: '66/70', total: 132 },
    { rank: 5, id: '2023089', name: '王十五', cls: '高三(3)班', objective: '65/80', subjective: '65/70', total: 130 },
    { rank: 6, id: '2023001', name: '张三', cls: '高三(1)班', objective: '64/80', subjective: '63/70', total: 127 },
    { rank: 7, id: '2023056', name: '赵十六', cls: '高三(2)班', objective: '62/80', subjective: '62/70', total: 124 },
];

export const STATS_BARS = [
    { label: '0-59', count: 8, height: 20, green: false },
    { label: '60-69', count: 18, height: 35, green: false },
    { label: '70-79', count: 45, height: 60, green: false },
    { label: '80-89', count: 82, height: 90, green: false },
    { label: '90-99', count: 68, height: 100, green: false },
    { label: '100-119', count: 43, height: 70, green: true },
    { label: '120-150', count: 18, height: 40, green: true },
];
